module.exports = __webpack_public_path__ + "components/MapControl/svg/Teren dawnej wsi.svg?c34811e8";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Teren dawnej wsi.svg
// module id = 2082
// module chunks = 0